import OutboundForm from './OutboundForm';

export default OutboundForm;
